import { render, staticRenderFns } from "./SearchSuggestionDropdown.vue?vue&type=template&id=7ff89a74&scoped=true&"
import script from "./SearchSuggestionDropdown.vue?vue&type=script&lang=ts&"
export * from "./SearchSuggestionDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSuggestionDropdown.vue?vue&type=style&index=0&id=7ff89a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff89a74",
  null
  
)

export default component.exports